module.exports = __webpack_public_path__ + "img/kosuzu motoori_sc1.b12efb01.png";